<button class="btn d-flex justify-content-center m-0" [class]="btnClass" [type]="type" [disabled]="disabled">
  <i *ngIf="icon" class="emp-icon" [class]="icon"></i>
  <span class="mb-auto button-text">{{ text }}</span>
</button>
